import { Typography, Paper, Button, Box } from '@mui/material';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Progress from './Progress';
import { ThumbUpAltTwoTone } from '@mui/icons-material';
import { toQuestionsView, toQuizOverview } from '../../utils/routes';
import { getSubtopicsProgress } from '../../utils/Quizze/getSubtopicsProgress';
import { useTranslation } from 'react-i18next';

export default function FinishedQuiz(props) {

    const {quizpartId, subtopicId} = useParams();
    const {i18n, t} = useTranslation();
    const navigate = useNavigate();

    const questions = props.questions.filter(quest => quest.subtopicId === subtopicId);
    const subtopics = props.subtopics.filter(topic => topic.quizpartId === quizpartId);
    const subtopic = subtopics.find(subtopic => subtopic.id === subtopicId);
    const quizpart = props.quizparts.find(quizpart => quizpart.id === quizpartId);
    
    if (!(questions && subtopic && quizpart)) return null;
    
    const subtopicsProgress = getSubtopicsProgress(subtopics, props.quizProgress);

    const findLastQuiz = () => {

        let activeSubtopic = subtopics.find(v => v.first);
        let ctr = 0;

        while(activeSubtopic) {            
            if (subtopicsProgress.length === ctr) {
                return activeSubtopic
            }
            ctr++;
            activeSubtopic = subtopics.find(v => v.id === activeSubtopic.nextSubtopicId)
        }
        return ""
    }

    const everythingUnlocked = subtopicsProgress.length === subtopics.length;
    const newSubtopic = findLastQuiz()


    const subtopicName = subtopic.name[i18n.language]
    const quizpartName = quizpart.name[i18n.language]

    const goToSubtopic = () => {
        navigate(toQuizOverview)
    }

    const moveToNewQuiz = () => {
        navigate(toQuestionsView(quizpartId, newSubtopic.id, 0))
    }
    
    return(
        <Box sx={{display: "flex", flexDirection:"column", alignItems: "center"}}>
            <Paper sx={{p: 4, m: 4, width: "18rem"}}>
                <Typography variant="h1">{subtopicName}</Typography>
                <Progress activeQuestion={questions.length} size={questions.length}/>
                <Paper sx={{mt: 2, p: 2, display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-evenly", mb: 2}}>
                        <Typography align="center">{t("quizFinishedTitle")}</Typography>
                        <ThumbUpAltTwoTone color="secondary" sx={{fontSize: "50px"}}/>
                    </Box>
                    <Box sx={{mb: 2}}>
                        {
                            everythingUnlocked ?
                            <Typography>{t("quizFinishedAll", {quizpartName: quizpartName})}</Typography>
                            :
                            <Box>
                                <Typography>{t("quizFinishedUnlocked")}:</Typography>
                                <Button variant="contained" color="secondary" onClick={moveToNewQuiz}
                                    sx={{mt: 1}}
                                >
                                {newSubtopic.name[i18n.language]}
                                </Button>

                            </Box>
                        }
                    </Box>
                    <Button variant="contained" onClick={goToSubtopic} sx={{mt: 2}}>{t("quizFinishedBack")}</Button>
                </Paper>
            </Paper>
        </Box>
    )
}